import styles from "../../../styles.module.scss";

import { createColumn } from "../utils";
import { MergedColumnType } from "../../types";
//UI
import type { ColumnType } from "antd/es/table";
import Checkbox from "antd/lib/checkbox";

export const menuTabsColumns = (
  intl: (id: string) => string,
  getColumnSearchProps?: (
    dataIndex: keyof MergedColumnType
  ) => ColumnType<MergedColumnType>,
  filters?: { text: string; value: boolean }[],
  data?: MergedColumnType[]
) => [
  createColumn(
    intl("menu-tab-name"),
    "name",
    undefined,
    undefined,
    (a, b) => a.name?.localeCompare(b.name),
    undefined,
    true,
    data
  ),
];
